import { LegalLayout } from './LegalLayout';

// EU e-commerce law requires a publicly reachable Imprint with the operator's
// real identity — name, address, registration, VAT. Do not remove details from
// this page without legal review.
export function Imprint() {
  return (
    <LegalLayout title="Imprint" lastUpdated="2026-04-22">
      <p>
        Markcat is operated by:
      </p>

      <h2>Operator</h2>
      <p>
        <strong>Danube Mechatronics Kft.</strong><br />
        1042 Budapest, József Attila utca 82. I/1<br />
        Hungary
      </p>

      <h2>Registration</h2>
      <ul>
        <li>Registry Number: 01-09-397578</li>
        <li>VAT (HU): 27780602-2-41</li>
        <li>VAT (EU): HU27780602</li>
      </ul>

      <h2>Contact</h2>
      <p>
        Bálint Kurucz MSc.<br />
        Email: <a href="mailto:office@danube-mechatronics.com">office@danube-mechatronics.com</a><br />
        Phone (HU): <a href="tel:+36209746131">+36 20 974 61 31</a><br />
        Phone (DE): <a href="tel:+4917643313420">+49 176 433 134 20</a>
      </p>

      <h2>EU Online Dispute Resolution</h2>
      <p>
        The European Commission provides a platform for online dispute resolution (ODR), available at{' '}
        <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noreferrer noopener">
          ec.europa.eu/consumers/odr
        </a>. We are not obligated to, and do not generally, participate in dispute resolution proceedings
        before a consumer arbitration board.
      </p>
    </LegalLayout>
  );
}
